import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {DOMEN} from '../../../../common/constants'
import {KiasDataForRenderResponseInterface} from '../../types/responses/data-for-render'
import {GetCostResponseInterface} from '../../types/responses/get-cost'
import {CalculateRequestInterface} from '../../types/requests/calculate-request'

export const expressApi = createApi({
    reducerPath: 'expressApi',
    baseQuery: fetchBaseQuery({baseUrl: `${DOMEN}/osago/express/calc`}),
    tagTypes: ['Express'],
    endpoints: builder => ({
        getDataForRender: builder.query<KiasDataForRenderResponseInterface, void>({
            query: () => `/data`,
        }),
        getCost: builder.query<GetCostResponseInterface, CalculateRequestInterface>({
            query: body => ({url: ``, method: 'POST', body: body}),
            providesTags: () => {
                return ['Express']
            },
        }),
    }),
})

export const useGetDataForRenderQuery = expressApi.endpoints.getDataForRender.useQuery
export const useGetCostQuery = expressApi.endpoints.getCost.useQuery
export const useGetCostLazy = expressApi.endpoints.getCost.useLazyQuery
